import Anchor from "~/components/Anchor";
import NotificationBanner, {
	NotificationBannerType,
} from "~/components/Notifications/NotificationBanner";
import { useCertification, useCertificationModule } from "~/hooks";

const CertificationNotifications = () => {
	const { certification } = useCertification();

	const { module } = useCertificationModule();

	const certificationWorkshopCredits = !!(
		certification.earnedWorkshopCredits && certification.linkedWorkshop
	);
	const moduleWorkshopCredits = !!(
		module?.earnedWorkshopCredits && certification.linkedWorkshop
	);

	const specialCredits = !!certification.specialCredits;

	const legacyCertification = !!certification.isLegacy;

	const isVisible =
		(certificationWorkshopCredits && !module) ||
		moduleWorkshopCredits ||
		legacyCertification;

	if (!isVisible) return null;

	return (
		<>
			{legacyCertification && (
				<NotificationBanner type={NotificationBannerType.WARNING}>
					<strong>Legacy Certification Notice:</strong> This is the original
					version of the certification.{" "}
					<Anchor
						href={`/certifications/${certification.slug.replace(
							"-original",
							"",
						)}`}
					>
						Click here
					</Anchor>{" "}
					if you want to access the latest version.
				</NotificationBanner>
			)}

			{module?.earnedWorkshopCredits ? (
				<NotificationBanner type={NotificationBannerType.SUCCESS}>
					<strong>Workshop Credits For Category:</strong> You have been awarded{" "}
					{module.earnedWorkshopCredits} credits in this category for completing
					the {certification.linkedWorkshop!.title} Workshop (
					{certification.linkedWorkshop?.credits} Total Credits awarded for the{" "}
					{certification.title} Certification).
				</NotificationBanner>
			) : certificationWorkshopCredits && !module ? (
				<NotificationBanner type={NotificationBannerType.SUCCESS}>
					<strong>Workshop Credits:</strong> You have been awarded{" "}
					{certification.earnedWorkshopCredits} credits in this certification
					for completing the {certification.linkedWorkshop!.title} workshop.
				</NotificationBanner>
			) : null}

			{specialCredits && (
				<NotificationBanner type={NotificationBannerType.INFO}>
					<strong>Credits For Prior Learning:</strong> You have been awarded{" "}
					{specialCredits} credits for the {certification.title} (
					{certification.title
						.split(" ")
						.map((s) => s[0])
						.join("")}
					) certification due to prior learning.
				</NotificationBanner>
			)}
		</>
	);
};

export default CertificationNotifications;
